import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import compose from 'recompose/compose';
import withHandlers from 'recompose/withHandlers';
import { bindActionCreators } from 'redux';
import { getRoleIdType } from '../../auth/selectors';
import { bindActionsForRoles } from '../../common/helpers/actions';
import {
  fetchBarberCampaign,
  fetchShopCampaign,
  fetchBrandCampaign,
  setDraftCampaign,
} from '../actions';

const withFetchCampaign = compose(
  withRouter,
  connect(
    (state, ownProps) => ({
      shopOrBarber: getRoleIdType(state),
      campaignId: ownProps.params.campaignId,
    }),
    dispatch => ({
      fetchCampaign: bindActionsForRoles(dispatch, fetchShopCampaign, fetchBarberCampaign, fetchBrandCampaign),
      setDraftCampaign: bindActionCreators(setDraftCampaign, dispatch),
    })
  ),
  withHandlers({
    fetchCampaign: props => () => props.fetchCampaign[props.shopOrBarber.type](
      props.shopOrBarber.id,
      props.campaignId,
    )
      .then(props.setDraftCampaign),
  })
);

export default withFetchCampaign;
